import { api } from "./api";

const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let _initialised = false;

function getSessionId() {
  try {
    let id = sessionStorage.getItem("kiki_sid");
    if (!id) {
      id = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("kiki_sid", id);
    }
    return id;
  } catch {
    return "anon";
  }
}

// Dynamically load GA4 + Meta Pixel only if IDs are configured via env.
export function initAnalytics() {
  if (_initialised || typeof window === "undefined") return;
  _initialised = true;

  // Google Analytics 4
  if (GA4_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID);
  }

  // Meta / Facebook Pixel
  if (META_PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

export function track(event, props = {}) {
  try {
    api.post("/analytics/event", {
      event,
      props,
      path: typeof window !== "undefined" ? window.location.pathname : null,
      session_id: getSessionId(),
    }).catch(() => {});

    if (typeof window !== "undefined") {
      if (window.posthog) { try { window.posthog.capture(event, props); } catch {} }
      if (GA4_ID && window.gtag) { try { window.gtag("event", event, props); } catch {} }
      if (META_PIXEL_ID && window.fbq) {
        try { window.fbq("trackCustom", event, props); } catch {}
      }
    }
  } catch {}
}
